import React, { forwardRef } from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLaptopCode, faBolt, faBuilding, faCogs } from '@fortawesome/free-solid-svg-icons';

const WhatWeDo = forwardRef((props, ref) => {
  const cards = [
    {
      title: "Computer Science (CSE)",
      description: "Cutting-edge solutions in AI, machine learning, and web technologies.",
      icon: faLaptopCode,
      gradient: "bg-gradient-to-br from-yellow-50 via-yellow-100 to-yellow-200",
      textColor: "text-orange-700",
      hoverColor: "text-orange-900",
      shadowColor: "rgba(255,165,0,0.4)"
    },
    {
      title: "Electrical & Electronics (EEE)",
      description: "Expertise in electrical systems, control circuits, and electronic solutions.",
      icon: faBolt,
      gradient: "bg-gradient-to-br from-blue-50 via-blue-100 to-blue-200",
      textColor: "text-blue-700",
      hoverColor: "text-blue-900",
      shadowColor: "rgba(59,130,246,0.4)"
    },
    {
      title: "Civil Engineering",
      description: "Advanced projects in construction, structural analysis, and environmental systems.",
      icon: faBuilding,
      gradient: "bg-gradient-to-br from-green-50 via-green-100 to-green-200",
      textColor: "text-green-700",
      hoverColor: "text-green-900",
      shadowColor: "rgba(34,197,94,0.4)"
    },
    {
      title: "Mechanical Engineering",
      description: "Specializing in thermodynamics, fluid mechanics, and mechanical design.",
      icon: faCogs,
      gradient: "bg-gradient-to-br from-pink-50 via-pink-100 to-pink-200",
      textColor: "text-pink-700",
      hoverColor: "text-pink-900",
      shadowColor: "rgba(236,72,153,0.4)"
    },
  ];

  return (
    <section ref={ref} className="py-16 bg-gradient-to-br from-yellow-200 via-yellow-300 to-yellow-100">
      <div className="container mx-auto px-6">
        <h2 className="text-4xl md:text-5xl font-bold mb-8 text-center text-black">
          What We Do?
        </h2>
        <p className="text-lg text-center text-gray-700 mb-12">
          Mindspark Innovations delivers specialized project solutions across various engineering disciplines.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {cards.map((card, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              whileHover={{ scale: 1.08, boxShadow: `0 12px 30px ${card.shadowColor}`, y: -5 }}
              transition={{ type: 'spring', stiffness: 300, damping: 20 }}
              className={`${card.gradient} p-6 rounded-3xl shadow-lg border border-gray-200 transition-all duration-300 group relative overflow-hidden`}
            >
              <motion.div
                animate={{ y: [0, -10, 0] }}
                transition={{ repeat: Infinity, duration: 2.5, ease: 'easeInOut' }}
                className="flex justify-center mb-4"
              >
                <FontAwesomeIcon
                  icon={card.icon}
                  className={`w-16 h-16 ${card.textColor} drop-shadow-lg group-hover:${card.hoverColor} transition-colors duration-300`}
                />
              </motion.div>
              <h3 className={`text-2xl font-semibold text-center mb-4 ${card.textColor} group-hover:${card.hoverColor} transition-colors duration-300`}>
                {card.title}
              </h3>
              <p className={`text-center ${card.textColor} group-hover:${card.hoverColor} transition-colors duration-300`}>
                {card.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
});

export default WhatWeDo;
